import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ApiService from '../../../services/ApiService';

const PasswordInput = ({ id, label, value, onChange, visible, onToggle }) => (
  <div className="mb-5">
    <label htmlFor={id} className="form-label fw-semibold required">{label}</label>
    <div className="position-relative">
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        className="form-control form-control-solid pe-12"
        value={value}
        onChange={onChange}
        autoComplete="new-password"
      />
      <button
        type="button"
        className="btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-2"
        onClick={onToggle}
        tabIndex={-1}
      >
        <i className={`bi ${visible ? 'bi-eye-slash' : 'bi-eye'} text-gray-500`}></i>
      </button>
    </div>
  </div>
);

const ChangePasswordModal = ({ show, user, onHide }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setNewPassword('');
      setConfirmPassword('');
      setShowNew(false);
      setShowConfirm(false);
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      toast.error('Password must be at least 6 characters long');
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    try {
      setIsSaving(true);
      const res = await ApiService.request({
        method: 'POST',
        url: `admin/users/${user._id}/password`,
        data: { new_password: newPassword, confirm_password: confirmPassword },
      });
      if (res.data.status) {
        toast.success(res.data.message);
        onHide();
      } else {
        toast.error(res.data.message);
      }
    } catch {
      // ApiService already surfaced the error.
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-6">
            Set a new password for <strong className="text-dark">{user?.name || user?.email || 'this user'}</strong>.
          </p>
          <PasswordInput
            id="user-new-password"
            label="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            visible={showNew}
            onToggle={() => setShowNew((v) => !v)}
          />
          <PasswordInput
            id="user-confirm-password"
            label="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            visible={showConfirm}
            onToggle={() => setShowConfirm((v) => !v)}
          />
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-light" onClick={onHide} disabled={isSaving}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={isSaving}>
            {isSaving ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> : null}
            Update Password
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ChangePasswordModal;
